<template>
  <div class="teachingActivities">
    <el-button size="small" type="primary" @click="addCurriculum" icon="el-icon-plus">添加教研活动</el-button>
    <el-form class="form-style" :inline="true" size="small">
      <el-form-item label="活动名称:">
        <el-input v-model="title" clearable placeholder="请输入活动名称" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="所属科目:">
        <el-select v-model="subject_id" clearable placeholder="请选择所属科目" @change="search">
          <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="table-style">
      <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>

        <el-table-column align="center" width="100" label="封面">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 18px" :src="scope.row.img_url" fit="fill"></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="subjectName" label="科目"></el-table-column>
        <el-table-column align="center" prop="title" label="标题" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="new_state" label="等级"></el-table-column>
        <el-table-column align="center" label="观看人数">
          <template slot-scope="scope">
            <el-link class="num" @click="tchList(scope.row)">{{ scope.row.tch_num }}</el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" label="群图片">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 18px" :src="scope.row.group_img_url" fit="fill"></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="activity_date" label="时间" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column align="center" label="观看列表">
          <template slot-scope="scope">
            <el-button size="small" @click="tchList(scope.row)">查看信息</el-button>
          </template>
        </el-table-column>-->

        <el-table-column align="center" label="操作" width="300px">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="editbtn(scope.row)">修改</el-button>
            <el-button size="small" type="text" @click="zhiding(scope.row)">置顶等级</el-button>

            <el-button size="small" type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" layout="total, prev, pager, next"
        :total="total" :page-size="20"></el-pagination>
    </div>

    <!-- <el-dialog title="添加教研活动" :visible.sync="dialogVisible">
      <el-form
        class="form-style"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
        label-position="left"
      >
        <el-form-item label="所属科目" required prop="subject_id">
          <el-select v-model="form.subject_id" placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" required prop="title">
          <el-input placeholder="请输入标题" v-model="form.title" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="主持人" required prop="host">
          <el-input placeholder="请输入主持人" v-model="form.host" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="活动类型" required prop="activity_type">
          <el-select v-model="form.activity_type" placeholder="请选择">
            <el-option
              v-for="item in activityType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="time">
          <el-form-item label="*活动时间" class="fl">
            <el-date-picker
              v-model="form.activity_start_date"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择开始日期"
            ></el-date-picker>
          </el-form-item>
          <div class="fl" style="margin: 0 20px">-</div>
          <el-form-item class="fl" label-width="0px">
            <el-date-picker
              v-model="form.activity_end_date"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择时间"
            ></el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="简要简绍" required prop="brief_content">
          <el-input type="textarea" v-model="form.brief_content" maxlength="400" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="*封面地址">
          <el-upload
            action
            ref="upload"
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChangeFile"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            list-type="picture"
            style="width: 400px"
          >
            <el-button size="small" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="margin-left: 10px">推荐尺寸: 370px * 260px</span>
              <span style="margin-left: 10px">只能上传jpg/png文件，且不超过500kb</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="置顶等级" required prop="new_state">
          <el-select v-model="form.new_state" placeholder="请选择">
            <el-option
              v-for="item in newState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知内容" required prop="notice_content">
          <div @click="changshow">
            <MarkDown
              v-if="showmarkdown"
              :markdown="form.notice_content"
              @SaveMarkDown="SaveMarkDown"
            ></MarkDown>
          </div>
        </el-form-item>
        <el-form-item label="活动介绍" required prop="main_content">
          <div @click="changshow">
            <MarkDown
              v-if="showmarkdown1"
              :markdown="form.main_content"
              @SaveMarkDown="SaveMarkDown1"
            ></MarkDown>
          </div>
        </el-form-item>
        <el-form-item label="*教师提问">
          <div @click="changshow">
            <MarkDown
              v-if="showmarkdown2"
              :markdown="form.tch_question_content"
              @SaveMarkDown="SaveMarkDown2"
            ></MarkDown>
          </div>
        </el-form-item>
        <el-form-item label="*资料下载">
          <div @click="changshow">
            <MarkDown
              v-if="showmarkdown3"
              :markdown="form.download_content"
              @SaveMarkDown="SaveMarkDown3"
            ></MarkDown>
          </div>
        </el-form-item>

        <el-form-item label="*群图片地址">
          <el-upload
            action
            ref="upload"
            :http-request="uploadFilequn"
            :on-remove="handleRemove1"
            :on-change="handleChangeFile1"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed1"
            :file-list="fileListqun"
            list-type="picture"
            style="width: 400px"
          >
            <el-button size="small" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="margin-left: 10px">推荐尺寸: 370px * 260px</span>
              <span style="margin-left: 10px">只能上传jpg/png文件，且不超过500kb</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="*录播视频地址">
          <el-input placeholder="请输入视频地址" v-model="form.video_url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>-->
    <!-- 是否置顶弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="30%">
      <el-form ref="form" :model="formGad" label-width="80px">
        <el-form-item label="置顶等级">
          <el-select v-model="formGad.new_state" placeholder="请选择">
            <el-option v-for="item in newState" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="isTopping">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 获取弹窗列表 -->
    <el-dialog title="观看信息" :visible.sync="dialogVisible2">
      <el-table :data="tableDataDialog2" style="width: 100%" height="500">
        <el-table-column prop="created_time" label="观看日期"></el-table-column>
        <el-table-column prop="schoolName" label="校区"></el-table-column>
        <el-table-column label="姓名" prop="created_time">
          <template slot-scope="scope">{{ scope.row.userInfo.realname }}</template>
        </el-table-column>
        <el-table-column label="电话">
          <template slot-scope="scope">{{ scope.row.userInfo.phone_num }}</template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page1_no" :page-size="page1_size"
          layout="total, prev, pager, next" :total="total1"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminGetResearchActivityList,
  // getAdminSubjectList,
  getAdminSubjectListWithOutPageInfo,
  isTopping,
  del,
  tchList
} from "@/api/admin.js";

// import uploadFile from "@/config/uploadFile";
// import uploadFilequn from "@/config/uploadFile";
// import MarkDown from "@/components/markdown";

export default {
  name: "teachingActivities",
  // components: {
  //   MarkDown: MarkDown
  // },
  data() {
    return {
      user: {},
      research: "",
      subjectList: [],
      tableDataDialog2: [],
      research_activity_id: "",
      formGad: {
        new_state: "",
        research_activity_id: ""
      },
      dialogVisible1: false,
      dialogVisible2: false,

      total1: 0,
      page1_no: 1,
      page1_size: 20,
      //课程封面
      newState: [
        {
          value: "0",
          label: "不置顶"
        },
        {
          value: "1",
          label: "1级"
        },
        {
          value: "2",
          label: "2级"
        },
        {
          value: "3",
          label: "3级"
        },
        {
          value: "4",
          label: "4级"
        },

        {
          value: "5",
          label: "5级"
        },
        {
          value: "6",
          label: "6级"
        }
      ],
      activityType: [
        {
          id: "1",
          name: "技能培训"
        },
        {
          id: "2",
          name: "教学技巧"
        },
        {
          id: "3",
          name: "其他分享"
        }
      ],
      // subjectList: [],
      startDate: "",
      endDate: "",
      title: "",
      subject_id: "",
      total: 0,
      page_no: 1,
      subjectId: "",
      fileList: [],
      fileListqun: [],
      form: {
        subject_id: "", //所属科目
        title: "", //标题
        activity_type: "", //活动类型
        activity_date: "", //活动日期
        brief_content: "", //简要介绍
        new_state: "", //置顶等级
        notice_content: "", //通知内容
        main_content: "", //活动介绍，
        tch_question_content: "", //教师提问
        video_url: "" //视频地址
      },
      tableData: [],
      rules: {
        host: [
          {
            required: true,
            message: "请输入主持人"
          }
        ],
        startDate: [
          {
            required: true,
            type: "date",
            message: "请选择开始时间",
            trigger: "change"
          }
        ],
        endDate: [
          {
            required: true,
            type: "date",
            message: "请选择结束时间",
            trigger: "change"
          }
        ],
        subject_id: [
          {
            required: true,
            message: "请选择科目"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入标题"
          }
        ],
        activity_type: [
          {
            required: true,
            message: "请选择活动类型"
          }
        ],
        activity_date: [
          {
            required: true,
            message: "请选择活动日期"
          }
        ],
        brief_content: [
          {
            required: true,
            message: "请输入简要介绍"
          }
        ],
        new_state: [
          {
            required: true,
            message: "请选择置顶等级"
          }
        ],
        notice_content: [
          {
            required: true,
            message: "请输入通知内容"
          }
        ],
        main_content: [
          {
            required: true,
            message: "请输入活动介绍"
          }
        ]
      }
    };
  },
  mounted() {
    this.getAdminSubjectListWithOutPageInfo();
    this.adminGetResearchActivityList();
  },
  methods: {
    handleCurrent(val) {
      this.page1_no = val;
      tchList({
        research_activity_id: this.research,
        page_no: this.page1_no,
        page_size: this.page1_size
      }).then(res => {
        console.log(res);
        this.tableDataDialog2 = res.researchActivityTchList;
        this.total1 = res.total;
      });
    },

    // //获取观看信息
    tchList(row) {
      this.dialogVisible2 = true;
      tchList({
        research_activity_id: row.id,
        page_no: this.page1_no,
        page_size: this.page1_size
      }).then(res => {
        console.log(res);
        this.tableDataDialog2 = res.researchActivityTchList;
        this.total1 = res.total;
        let a = row.id;
        this.research = a;
      });
    },

    //弹窗层级
    // changshow() {
    //   console.log(123456);
    //   console.log(document.getElementsByClassName("v-modal"));
    //   let a = document.getElementsByClassName("v-modal");
    //   for (var i in a) {
    //     console.log(a[i].style.cssText);
    //     a[i].style.cssText = 0;
    //   }
    // },
    //编辑
    editbtn(row) {
      this.$router.push({
        name: "addTeachingActivities",
        query: {
          row: JSON.stringify(row)
        }
      });

      //

      console.log(row);
      console.log(this.fileList);
      this.fileList = [];
      this.fileListqun = [];

      this.fileList.push({
        url: row.img_url
      });
      this.fileListqun.push({
        url: row.group_img_url
      });

      this.form = row;
      // let end = "";
      this.research_activity_id = row.id;
      this.dialogVisible = true;
    },
    //是否置顶弹窗
    zhiding(row) {
      this.dialogVisible1 = true;
      console.log(row.id, "测试");
      this.formGad.research_activity_id = row.id;
    },
    //通知内容
    // SaveMarkDown(md, html) {
    //   console.log("保存markdown");
    //   console.log(md);
    //   console.log(html);
    //   this.form.notice_content = md;
    //   let a = document.getElementsByClassName("v-modal");
    //   for (let i in a) {
    //     console.log(a[i].style.cssText);
    //     a[i].style.cssText = 9999;
    //   }
    // },
    // SaveMarkDown1(md, html) {
    //   console.log("保存markdown");
    //   console.log(md);
    //   console.log(html);
    //   this.form.main_content = md;
    //   let a = document.getElementsByClassName("v-modal");
    //   for (let i in a) {
    //     console.log(a[i].style.cssText);
    //     a[i].style.cssText = 9999;
    //   }
    // },
    // SaveMarkDown2(md, html) {
    //   console.log("保存markdown");
    //   console.log(md);
    //   console.log(html);
    //   this.form.tch_question_content = md;
    //   let a = document.getElementsByClassName("v-modal");
    //   for (let i in a) {
    //     console.log(a[i].style.cssText);
    //     a[i].style.cssText = 9999;
    //   }
    // },
    // SaveMarkDown3(md, html) {
    //   console.log("保存markdown");
    //   console.log(md);
    //   console.log(html);
    //   this.form.download_content = md;
    //   let a = document.getElementsByClassName("v-modal");
    //   for (let i in a) {
    //     console.log(a[i].style.cssText);
    //     a[i].style.cssText = 9999;
    //   }
    // },

    // 群地址
    // uploadFilequn() {},
    // async handleChangeFile1(file, fileListqun) {
    //   console.log("handleChangeFile1");
    //   console.log(fileListqun);

    //   if (!this.uploadFileTime) {
    //     await this.uploadFileOss1(fileListqun);
    //   }
    // },
    // async uploadFileOss1(list) {
    //   this.uploadFileTime = true;
    //   await uploadFilequn(list, this.$store.state.user.userInfo.code).then(
    //     res => {
    //       console.log("上传文件");
    //       console.log(res);
    //       res.map(item => {
    //         this.form.group_img_url = item.url;
    //         console.log(item.url);
    //       });
    //       this.fileListqun = res;
    //       this.uploadFileTime = false;
    //       console.log(this.$refs.form, "555555555");
    //       this.$nextTick(() => {
    //         this.rules.fileUpdate1 = [];
    //       });
    //     }
    //   );
    // },
    // handleRemove1(file, fileListqun) {
    //   console.log(file, fileListqun);
    // },

    // handleExceed1() {
    //   this.$message.warning("请删除原有文件,再重新上传");
    // },

    //课程封面
    // uploadFile() {},
    // async handleChangeFile(file, fileList) {
    //   console.log("handleChangeFile");
    //   console.log(fileList);

    //   if (!this.uploadFileTime) {
    //     await this.uploadFileOss(fileList);
    //   }
    // },
    // async uploadFileOss(list) {
    //   this.uploadFileTime = true;
    //   await uploadFile(list, this.$store.state.user.userInfo.code).then(res => {
    //     console.log("上传文件");
    //     console.log(res);
    //     res.map(item => {
    //       this.form.img_url = item.url;
    //       this.form.group_img_url = item.url;
    //     });
    //     this.fileList = res;
    //     this.uploadFileTime = false;
    //     this.rules.fileUpdate = [];
    //   });
    // },
    // handleRemove(file, fileList) {
    //   console.log(file, fileList);
    // },

    // handleExceed() {
    //   this.$message.warning("请删除原有文件,再重新上传");
    // },

    //获取科目
    getAdminSubjectListWithOutPageInfo() {
      getAdminSubjectListWithOutPageInfo({
        subject_state: 1
      }).then(res => {
        console.log(res, 1245487);
        this.subjectList = res.subject_list;
      });
    },
    search() {
      this.page_no = 1;
      this.adminGetResearchActivityList();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.adminGetResearchActivityList();
    },
    addCurriculum() {
      this.$router.push({
        name: "addTeachingActivities",
        query: {
          act: "add"
        }
      });
      //
      // this.form = {};
      // console.log(this.form.main_content, 456789798465465);
      // this.fileList = [];
      // this.fileListqun = [];
      // this.research_activity_id = "";
      // this.startDate = "";
      // this.endDate = "";
      // // this.form.notice_content = ""
      // console.log(this.form, 66666);
      // this.getAdminSubjectList();
      // this.dialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs["form"].clearValidate();
      // });
    },

    //新增编辑
    // submit(form) {
    //   if (this.fileList.length === 0) {
    //     this.$message.warning("请上传封面图片");
    //   } else if (this.fileListqun.length === 0) {
    //     this.$message.warning("请上传群图片");
    //   } else {
    //     this.$refs[form].validate(valid => {
    //       if (valid) {
    //         if (this.research_activity_id === "") {
    //           this.form.activity_end_date.substr(0, 16);
    //           this.form.activity_date =
    //             this.form.activity_start_date +
    //             "-" +
    //             this.form.activity_end_date.substr(10, 13);
    //           console.log(this.startDate);
    //           console.log(this.endDate);
    //           console.log(this.form.activity_date);
    //           addCurriculum({
    //             research_activity_id: "",
    //             ...this.form
    //           }).then(res => {
    //             console.log(res);
    //             this.dialogVisible = false;
    //             this.$message.success("创建成功");
    //             this.adminGetResearchActivityList();
    //           });
    //         } else {
    //           addCurriculum({
    //             research_activity_id: this.research_activity_id,
    //             ...this.form
    //           }).then(() => {
    //             this.$message.success("修改科目成功！");
    //             this.dialogVisible = false;
    //             this.adminGetResearchActivityList();
    //             console.log(this.form, 45546456);
    //           });
    //         }
    //       }
    //     });
    //   }
    // },

    //是否置顶
    isTopping() {
      isTopping(
        {
          research_activity_id: this.formGad.research_activity_id,
          new_state: this.formGad.new_state
        },
        true
      ).then(() => {
        this.dialogVisible1 = false;
        this.$message.success("置顶成功");
        this.adminGetResearchActivityList();
      });
    },

    del(row) {
      this.$confirm("确定删除当前科目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        del(
          {
            research_activity_id: row.id
          },
          true
        ).then(() => {
          this.$message.success("删除成功！");
          this.adminGetResearchActivityList();
        });
      });
    },
    //获取列表
    adminGetResearchActivityList() {
      adminGetResearchActivityList({
        title: this.title,
        subject_id: this.subject_id,
        page_no: this.page_no,
        page_size: 20
      }).then(res => {
        console.log("平台科目");
        console.log(res);
        this.tableData = res.researchActivityList;
        this.total = res.total;
      });
    }
  }
};
</script>



<style scoped lang="scss">
.time {
  overflow: hidden;
}

.fl {
  float: left;
}

.teachingActivities {
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 10px;
  padding: 15px;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .table-style {
    margin-top: 15px;
  }
}

.num {
  cursor: pointer;
}
</style>
